import React, { useEffect, useRef, useState } from "react";
import ReusableDataTable from "../../Component/DataTable/ReusableDataTablePrime";
import { Autocomplete, Box, Button, Checkbox, FormControlLabel, FormGroup, IconButton, Popover, TextField, Typography } from "@mui/material";
import { OverlayPanel } from "primereact/overlaypanel";
import ReusablePrimeButton from "../../Component/Buttons/ReusablePrimeButton";
import { useDispatch } from "react-redux";
import { DataTable } from "primereact/datatable";
import { FilterMatchMode } from "primereact/api";
import { getStockColumnnns, getStockColumns, stockBodyTable, stockBodyTableIcon } from "../../const/StockData";
import { stockTypes } from "../../types/stockTypes";
import { setLoading } from "../../store/CommonSlice";
import { CustomMessage } from "../../const/Spinner";
import { enqueueSnackbar } from "notistack";
import { createStockData, deleteStockDetails, getListOfStock, } from "../../api/Services/stockService";
import Swal from "sweetalert2";
import CreateStock from "../StockManagement/CreateStockInventory";
import { FILE_DOWNLOAD_PREVIEW, PAGESEND, PAGESTART } from "../../api/endpoint";
import FilterListIcon from '@mui/icons-material/FilterList';
import { getStockCodeButtonData, getStockCodeDatabaseButtonData, getStockSearchAndExportData } from "../../const/AssertData";
import { getCountryAssetMasterDataList, getCurrencyAssetMasterDataList, getLocalStoreByCountryId, getStockCodeMasterDataList, saveStockCode } from "../../api/Services/masterServie";
import { StockCodeMaster } from "../../types/assetTypes";
import { getAssertButtonData } from "../../const/AssertData";
import { getStockButtonData } from "../../const/AssertData";
import "xlsx-color";
import ImagePreview from "../../Component/ImagePreview";
import { handleLogisticsFilter, handleStock, handleStockFilter } from "../../api/Services/assetServices";
import CreateStockCode from "../StockManagement/CreateStockCode";


const StockDatabase: React.FC = () => {
  const dt = useRef<DataTable<any[]>>(null);
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const [products, setProducts] = useState<stockTypes[]>([]);
  const [selectedProducts, setSelectedProducts] = useState<any[]>([]);
  const [stockCodeId, setStockCodeId] = useState<number | null>(null);
  const overlayPanelRef = useRef<OverlayPanel>(null);
  const [selectedValue, setSelectedValue] = useState<number | null>(null);
  const [paginationData, setPaginationData] = useState<{
    page: number;
    rows: number;
    totalRecords: number;
  }>({
    page: 1,
    rows: 13,
    totalRecords: 0,
  });



  const [countryName, setCountryName] = useState<
    { label: string; value: string | null }[]
  >([]);

  useEffect(() => {
    if (countryName.length === 0) getCountryNamesList(1, PAGESEND);
  }, [countryName]);



  const [localStore, setLocalStore] = useState<
    { label: string; value: string | null }[]
  >([]);

  const [globalFilterValue, setGlobalFilterValue] = useState("");

  const getCountryNamesList = async (page: number, rows: number) => {
    dispatch(setLoading(true));
    try {
      const { data, status } = await getCountryAssetMasterDataList(page, rows, { currentLocationId: { value: "", matchMode: "startsWith" } });
      if (status.code === 200 && data?.length > 0) {
        const updatedData: { label: string; value: string | null }[] = data.map((val) => ({
          value: val.currentLocationId.toString(),
          label: val.countryName,
        }));
        updatedData.unshift({ label: "Select Country", value: null });
        setCountryName(updatedData);

      }
    } catch (error: any) {
      CustomMessage(error?.message, "error", enqueueSnackbar);
    } finally {
      dispatch(setLoading(false));
    }
  };


  const getLocalStoreList = async (currentLocationId: number) => {
    dispatch(setLoading(true));
    try {
      const { data, status } = await getLocalStoreByCountryId(currentLocationId);

      if (status.code === 200 && data?.localStores?.length > 0) {
        const updatedData: { label: string; value: string | null }[] = data.localStores.map(
          (val: { localStoreId: number; localStoreName: string }) => ({
            value: String(val.localStoreId), // Convert to string
            label: val.localStoreName ?? "", // Ensure it's a string
          })
        );

        setLocalStore(updatedData);
      }
    } catch (error: any) {
      CustomMessage(error?.message, "error", enqueueSnackbar);
    } finally {
      dispatch(setLoading(false));
    }
  };


  //const [familyAsset, setFamilyAsset] = useState<assetFamilyMaster[]>([]);

  const onGlobalFilterChange = (e: { target: { value: any } }) => {
    console.log(e.target)

  };

  const exportCSV = (selectionOnly: boolean) => {
    if (!dt.current) {
      alert("No data available to export.");
      return;
    }

    // Get table data from PrimeReact's DataTable
    const data = dt.current.props.value || [];

    if (selectionOnly) {
      const selectedData = dt.current.props.selection || [];
      if (selectedData.length === 0) {
        alert("No rows selected for export.");
        return;
      }
      exportToExcel(selectedData);
    } else {
      exportToExcel(data);
    }
  };

  const exportToExcel = (data: any[]) => {
    if (!data || data.length === 0) {
      alert("No data to export.");
      return;
    }


    const XLSX = require("xlsx");

    const rows = data.map((row) => ({
      "Stock Code ID": row.stockCodeId ?? "",
      "Stock Code": row.stockCode ?? "",
      "Description": row.stock_description ?? "",
      "Original MFG": row.original_mfg ?? "",
      "Model/Part No": row.model_part_no ?? "",
      "Stock Category": row.stock_category ?? "",
      "Current Stock": row.currentStock ?? "",
      "Quantity": row.qty ?? "",
      "Unit Price": row.unit_price ?? "",
      "Total Price": row.total_price ?? "",
      "Rack Location": row.location ?? "",
      "Country": row.location_name ?? "",
      "Local Store": row.localStore ?? "",
      "Supplier": row.supplier ?? "",
      "Unit": row.unit ?? "",
      "Currency": row.currency ?? "",
      "Date": row.date ? new Date(row.date).toLocaleDateString("en-IN") : "",
      "Attachments": row.stockAttachmentId ? "Download Stock Image" : "No Attachment",
    }));

    // Convert JSON to worksheet
    const worksheet = XLSX.utils.json_to_sheet(rows);

    // Get the range of the worksheet
    const range = XLSX.utils.decode_range(worksheet["!ref"] || "");

    // Loop through all rows to apply hyperlinks
    for (let R = range.s.r + 1; R <= range.e.r; ++R) {  // Skip header row (start from second row)
      const cellAddress = XLSX.utils.encode_cell({ r: R, c: Object.keys(rows[0]).indexOf("Attachments") }); // Get the correct cell for "Attachments"

      // if (worksheet[cellAddress] && worksheet[cellAddress].v === "Download Stock Image") {
      if (worksheet[cellAddress] && worksheet[cellAddress].v.startsWith("Download")) {
        const attachmentId = data[R - 1]?.stockAttachmentId;

        if (attachmentId) {
          worksheet[cellAddress].l = { Target: FILE_DOWNLOAD_PREVIEW + attachmentId, Tooltip: "Click to download" };
          worksheet[cellAddress].s = {
            font: { color: { rgb: "FF0000" }, underline: true }, // Red text & underlined
          };
        }
      }
    }


    const wb = XLSX.utils.book_new();



    // Create worksheet and workbook

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Stock Data");

    // Apply formatting (bold headers + column width)

    worksheet["!cols"] = Object.keys(rows[0]).map(() => ({ wch: 20 })); // Set column width

    if (range) {
      for (let C = range.s.c; C <= range.e.c; ++C) {
        const cellAddress = XLSX.utils.encode_col(C) + "1"; // First row (headers)
        if (!worksheet[cellAddress]) continue;
        worksheet[cellAddress].s = { font: { bold: true } }; // Apply bold font to headers
      }
    } else {
      console.warn("Worksheet range is null. Skipping header formatting.");
    }


    // Define the header row
    const headerRow = Object.keys(rows[0]);

    // Adjust column width
    worksheet["!cols"] = headerRow.map(() => ({ wch: 20 }));

    // Apply styles to header row using `xlsx-color`
    headerRow.forEach((col, index) => {
      const cellAddress = XLSX.utils.encode_col(index) + "1"; // A1, B1, etc.

      if (worksheet[cellAddress]) {
        worksheet[cellAddress].s = {
          font: { bold: true, color: { rgb: "FFFFFF" } }, // White text
          fill: { fgColor: { rgb: "0074D9" } }, // Blue background
          alignment: { horizontal: "center", vertical: "center" },
          border: {
            top: { style: "thin", color: { rgb: "000000" } },
            bottom: { style: "thin", color: { rgb: "000000" } },
            left: { style: "thin", color: { rgb: "000000" } },
            right: { style: "thin", color: { rgb: "000000" } },
          },
        };
      }
    });

    // Add worksheet to workbook
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");




    // Save the Excel file
    XLSX.writeFile(workbook, "stock_data.xlsx");
  };

  const { inputField, headerButtons } = getStockSearchAndExportData(
    globalFilterValue,
    onGlobalFilterChange,
    exportCSV
  );

  const handleAddStock = async (newStockData: any) => {
    setLoading(true);
    try {
      const response = await saveStockCode(newStockData);
      let { status } = response;
      if (status.code === 200 || status.code === 201) {
        CustomMessage(status.message, "success", enqueueSnackbar);
        CustomMessage("StockCode added successfully", "success", enqueueSnackbar);
      } else {
        CustomMessage("Failed to add the stockcode.", "error", enqueueSnackbar);
      }
    } catch (error: any) {
      CustomMessage(error?.message || "Something went wrong!", "error", enqueueSnackbar);
    } finally {
      setLoading(false);
    }
  };


  const handleDeleteAll = (selectionOnly: stockTypes[]) => {
    if (selectionOnly.length === 0) {
      return;
    }
    Swal.fire({
      title: "Are you sure?",
      text: "You won’t be able to revert this all!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",
    }).then(async (result) => {
      if (result.isConfirmed) {
        selectionOnly.map(async (val) => {
          try {
            dispatch(setLoading(true));
            const response = await deleteStockDetails(val?.stockId);
            if (response.status === 200) {
              onFetchData(paginationData.page, paginationData.rows, filterData);
              CustomMessage("Data deleted", "success", enqueueSnackbar);
            } else {
              CustomMessage(
                "Failed to delete the asset.",
                "error",
                enqueueSnackbar
              );
            }
          } catch (error: any) {
            CustomMessage(error?.message, 'error', enqueueSnackbar);
          } finally {
            dispatch(setLoading(false));
          }
        })
      }
    });
  }


  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [subAnchorEl, setSubAnchorEl] = useState<null | HTMLElement>(null);
  // const [filterCol, setFilterCol] = useState<string | null>(null);


  const [selectedValues, setSelectedValues] = useState<string[]>([]);
  type Column = {
    key: string;
    label: string;
    values?: string[]; // Optional if values might not always exist
  };

  const openSubPopover = (
    event: React.MouseEvent<HTMLElement>,
    col: Column
  ) => {
    setSubAnchorEl(event.currentTarget);

    setSelectedValues(col.values || []);
  };

  const closeSubPopover = () => {
    setSubAnchorEl(null);

  };
  const [columnns, setColumns] = useState<{ key: string; label: string }[]>([]);

  const closeVisibilityPopover = () => {
    setAnchorEl(null);

    setSearchText(''); // clear search input
  };
  type Filters = {
    [key: string]: {
      value: string[]; // <- expects an array
    };
  };


  const handleSubmit = (newFilters: Filters) => {
    console.log("Submitted Filters:", newFilters);
    setFilterData(newFilters);
    onFetchData(paginationData.page, paginationData.rows, newFilters);
    closeSubPopover();
    closeVisibilityPopover();
  };



  const handleCancel = () => {

    closeSubPopover();     // ✅ Close the popover
  };
  const openVisibilityPopover = async (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget); // Anchor the popover

    // Fetch asset column data on click
    dispatch(setLoading(true));

    try {
      const response = await handleStock(); // Get the full response


      console.log("API Response:", response); // Log the full response

      // Check if the response is valid and contains the 'data' object
      if (response && response.status && response.status.code === 200 && response.data) {
        const data = response.data;

        setColumnData(data); // Store the full data, if needed for later

        // Map through each key in the response's data object
        const formattedCols = Object.keys(data).map((key) => ({
          key,
          label: key.replace(/_/g, " "), // Make the key more readable by replacing underscores with spaces
          values: data[key].map((item: { name: string }) => item.name), // Access the 'name' property of each object
        }));

        console.log("Formatted Columns:", formattedCols); // Log formatted columns for debugging
        setColumns(formattedCols); // Store formatted columns in state
      } else {
        // If response does not contain valid data, show an error message
        CustomMessage("Failed to fetch valid data", "error", enqueueSnackbar); // Custom error message
      }
    } catch (error: any) {
      // Handle any errors and display custom error messages
      CustomMessage(error.message, "error", enqueueSnackbar); // Custom error message on failure
    } finally {
      // Stop the loading indicator when the request completes (success or error)
      dispatch(setLoading(false));
    }
  };

  const handleClearFilter = () => {
    // Clear filters and related UI states
    setFilterData({});
    setTempFilters({});
    setFilters({});
    setSelectedValues([]);
    setFilterCol("");
    setSearchText("");
    setSubAnchorEl(null); // Close second popover if open
    setAnchorEl(null);    // Close first popover if open

    // Refetch data without any filters
    onFetchData(paginationData.page, paginationData.rows, {});
  };



  const buttonData = getStockCodeDatabaseButtonData(
    // /initFilters,
    handleClearFilter,
    overlayPanelRef,
    selectedProducts,
    openVisibilityPopover

  );



  type AssetItem = {
    id: number;
    name: string;
  };
  // const [searchText, setSearchText] = useState("");
  type AssetColumnData = {
    [key: string]: AssetItem[];
  };
  // const [filters, setFilters] = useState<Filters>({});
  const [filters, setFilters] = useState<Filters>({});
  useEffect(() => {
    console.log("Filters updated:", filters);
  }, [filters]);
  const [tempFilters, setTempFilters] = useState<Filters>({}); // ✨ temporary filters
  const [filterCol, setFilterCol] = useState<string>('');
  // const [checkedValues, setCheckedValues] = useState<string[]>([]);
  const [searchText, setSearchText] = useState('');
  useEffect(() => {
    console.log("Updated filterCol inside useEffect:", filterCol);
  }, [filterCol]);


  const [columnData, setColumnData] = useState<AssetColumnData>({});
  const currentColValues = (columnData[filterCol] || []).map((item: { name: string }) => item.name);
  const filteredValues = currentColValues.filter((val: string) =>
    val.toLowerCase().includes(searchText.toLowerCase())
  );



  const handleSearch = () => {
    onFetchData(PAGESTART, PAGESEND, {}, searchText); // Call with search text
  };

  const [selectedCountryId, setSelectedCountryId] = useState<string | null>(null);
  const [selectedLocalStore, setSelectedLocalStore] = useState<string | null>(null);


  // type FilterValue = {

  //   value: string[];
  // };

  // type Filters = {
  //   [key: string]: FilterValue;
  // };





  const renderHeader = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "space-between", // ⬅️ pushes left & right
          alignItems: "center",
          width: "100%",
          padding: "8px",
          flexWrap: "wrap",
          gap: "12px",
        }}
      >
        {/* 🔹 Left Side: Buttons + Filter */}
        <div style={{ display: "flex", alignItems: "center", gap: "12px", flexWrap: "wrap" }}>
          {/* Buttons */}
          <div style={{ display: "flex", gap: "8px", flexWrap: "wrap" }}>
            {buttonData &&
              buttonData.map((val) => <ReusablePrimeButton key={val.label} {...val} />)}
            {headerButtons &&
              headerButtons.map((btn, index) => <ReusablePrimeButton key={index} {...btn} />)}
          </div>


          <Popover
            open={!!anchorEl}
            anchorEl={anchorEl}
            onClose={closeVisibilityPopover}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
          >
            <FormGroup sx={{ p: 2, minWidth: 220 }}>
              {columnns.map((col) => (
                <Box
                  key={col.key}
                  sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    cursor: 'pointer',
                    px: 1,
                    py: 0.5,
                    '&:hover': { backgroundColor: '#f5f5f5', borderRadius: 1 },
                  }}
                  onClick={(e) => {
                    e.stopPropagation();
                    setFilterCol(col.key);

                    const currentChecked =
                      tempFilters[col.key]?.value || filters[col.key]?.value || [];
                    // setCheckedValues(currentChecked);

                    openSubPopover(e, col);
                  }}
                >
                  <Typography variant="body2">{col.label}</Typography>
                  <IconButton
                    size="small"
                    onClick={(e) => {
                      e.stopPropagation();
                      setFilterCol(col.key);

                      const currentChecked =
                        tempFilters[col.key]?.value || filters[col.key]?.value || [];
                      // setCheckedValues(currentChecked);

                      openSubPopover(e, col); // Pass the full Column object here
                    }}

                  >
                    <FilterListIcon fontSize="small" />
                  </IconButton>
                </Box>
              ))}
            </FormGroup>
          </Popover>


          <Popover
            open={!!subAnchorEl}
            anchorEl={subAnchorEl}
            onClose={closeSubPopover}
            anchorOrigin={{ vertical: 'center', horizontal: 'right' }}
            transformOrigin={{ vertical: 'center', horizontal: 'left' }}
          >
            <Box sx={{ p: 2, width: 250 }}>
              <Typography variant="body2" gutterBottom>
                Filter by {filterCol.replace(/_/g, ' ')}
              </Typography>

              <TextField
                fullWidth
                variant="outlined"
                size="small"
                placeholder={`Search ${filterCol}`}
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
                sx={{ mt: 1 }}
              />

              <Box sx={{ mt: 2 }}>
                <FormControlLabel
                  control={
                    <Checkbox
                      size="small"
                      checked={
                        filteredValues.length > 0 &&
                        filteredValues.every((value) =>
                          tempFilters[filterCol]?.value?.includes(value)
                          // ||
                          //   checkedValues.includes(value)
                        )
                      }
                      onChange={(e) => {
                        const currentValues = Array.isArray(tempFilters[filterCol]?.value)
                          ? tempFilters[filterCol].value
                          : [];

                        const newChecked = e.target.checked
                          ? Array.from(new Set([...currentValues, ...filteredValues]))
                          : currentValues.filter((v) => !filteredValues.includes(v));

                        setTempFilters((prev) => ({
                          ...prev,
                          [filterCol]: { value: newChecked },
                        }));



                        setTempFilters((prev) => ({
                          ...prev,
                          [filterCol]: { value: newChecked },
                        }));
                      }}
                    />
                  }
                  label={<Typography variant="body2">Select All</Typography>}
                />
              </Box>

              <Box sx={{ mt: 1 }}>
                {filteredValues.map((value, index) => (
                  <FormControlLabel
                    key={index}
                    control={
                      <Checkbox
                        size="small"
                        checked={
                          tempFilters[filterCol]?.value?.includes(value)
                          // ||
                          // checkedValues
                          // .includes(value)
                        }
                        // onChange={(e) => {
                        //   const isChecked = e.target.checked;
                        //   const current = tempFilters[filterCol]?.value;
                        //   // || checkedValues

                        //   const updated = isChecked
                        //     ? [...current, value]
                        //     : current.filter((v) => v !== value);
                        //   setTempFilters((prev) => ({
                        //     ...prev,
                        //     [filterCol]: { value: updated },
                        //   }));
                        // }}
                        onChange={(e) => {
                          const isChecked = e.target.checked;
                          const current = tempFilters[filterCol]?.value || []; // Ensure current is always an array

                          const updated = isChecked
                            ? [...current, value] // Add value if checked
                            : current.filter((v) => v !== value); // Remove value if unchecked

                          setTempFilters((prev) => ({
                            ...prev,
                            [filterCol]: { value: updated },
                          }));
                        }}
                      />
                    }
                    label={<Typography variant="body2">{value}</Typography>}
                  />
                ))}
              </Box>

              <Box sx={{ mt: 2, display: 'flex', gap: 2 }}>
                <Button variant="outlined" color="secondary" onClick={handleCancel}>
                  Close
                </Button>
                <Button
                  variant="contained"
                  onClick={() => {
                    const newFilters: Filters = {
                      ...filters,
                      ...tempFilters,
                    };
                    setFilters(newFilters);
                    handleSubmit(newFilters);
                    //  setTempFilters({});
                    // setCheckedValues([]);
                    setSearchText('');
                    closeSubPopover();
                    closeVisibilityPopover();
                  }}
                >
                  Submit
                </Button>
              </Box>
            </Box>
          </Popover>
          {/* ... keep your popovers here unchanged */}
        </div>

        {/* 🔹 Right Side: Search */}
        <div style={{ display: "flex", alignItems: "center" }}>
          <input
            type="text"
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            placeholder="Search..."
            style={{
              padding: "8px",
              borderRadius: "4px",
              border: "1px solid #ccc",
              width: "250px",
            }}
          />
          <button
            onClick={handleSearch}
            style={{
              padding: "8px 12px",
              marginLeft: "8px",
              borderRadius: "4px",
              border: "none",
              backgroundColor: "#007bff",
              color: "white",
              cursor: "pointer",
            }}
          >
            Search
          </button>
        </div>
      </div>
    );
  };


  const handleDeleteStock = async (stockId: number) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won’t be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",
    }).then(async (result) => {
      if (result.isConfirmed) {
        setLoading(true);
        try {
          const response = await deleteStockDetails(stockId);
          if (response.status === 204) {
            onFetchData(paginationData.page, paginationData.rows);
            CustomMessage("Data deleted", "success", enqueueSnackbar);
          } else {
            CustomMessage(
              "Failed to delete the asset.",
              "error",
              enqueueSnackbar
            );
          }
        } catch (error: any) {
          CustomMessage(
            error?.message || "Something went wrong!",
            "error",
            enqueueSnackbar
          );
        } finally {
          setLoading(false);
        }
      } else {
        CustomMessage("Deletion cancelled", "info", enqueueSnackbar);
      }
    });
  };

  const onFetchData = async (page: number, rows: number, filter?: Filters, searchTerm: string = searchText) => {
    dispatch(setLoading(true));
    try {
      const response = await getListOfStock(page, rows, filter, searchTerm);
      const { data, status, pagination } = response;
      if (status.code === 200 && data != null && data?.length > 0) {
        setProducts(response.data);
        setPaginationData({
          page: pagination.currentPage,
          rows: pagination.limit,
          totalRecords: pagination.totalCount,
        });
      } else {
        setProducts([]);
        // CustomMessage("No data", "error", enqueueSnackbar);
      }
    } catch (error: any) {
      CustomMessage(error?.message, "error", enqueueSnackbar);
    } finally {
      dispatch(setLoading(false));
    }
  };

  const handleEditStock = (stockId: number) => {
    setStockCodeId(stockId);
    setOpen(true);
  };
  const actionBodyTemplate = (rowData: stockTypes) => {
    const renderIconData = stockBodyTable(
      handleEditStock,
      handleDeleteStock,
      rowData,
      openVisibilityPopover
    );
    return (
      <>
        {renderIconData &&
          renderIconData.map((val, index) => (
            <ReusablePrimeButton key={index} {...val} />
          ))}
      </>
    );
  };
  const ImageRendering = (rowData: any) => {
    const attachmentId = rowData.stockAttachmentId || 0; // Fallback image
    return (
      <div className="flex align-items-center gap-2">
        {
          (attachmentId != 0 && attachmentId != null) && (
            <ImagePreview
              src={`${FILE_DOWNLOAD_PREVIEW + attachmentId}`}
              alt={`Attachment ${attachmentId}`}
              style={{
                width: "19px",
                height: "19px",
                borderRadius: "50%",
                objectFit: "cover"
              }}
            />
          )
        }
        {/* <span>{attachmentId}</span> */}
      </div>
    );
  }

  const [selectedCurrency, setSelectedCurrency] = useState("USD");
  const [exchangeRates, setExchangeRates] = useState<Record<string, number>>({});

  const fetchCurrencyRates = async () => {
    try {
      const response = await getCurrencyAssetMasterDataList(PAGESTART, PAGESEND, {}); // You can adjust limits
      if (response.status.code === 200 && response.data.length > 0) {
        const formattedRates: Record<string, number> = {};

        response.data.forEach((cur: any) => {
          const name = cur.insuranceCurrency?.trim(); // Remove extra spaces
          const value = parseFloat(cur.unitValue);
          if (name && !isNaN(value)) {
            formattedRates[name] = value;
          }
        });

        setExchangeRates(formattedRates);

        // Optional: Set default currency to one of the keys
        if (!selectedCurrency && formattedRates["USD"]) {
          setSelectedCurrency("USD");
        }
      }
    } catch (error) {
      console.error("Failed to fetch currency data", error);
    }
  };

  useEffect(() => {
    fetchCurrencyRates();
  }, []);



  const columns = getStockColumnnns(actionBodyTemplate, ImageRendering, selectedCurrency, exchangeRates, setSelectedCurrency);

  const [filterData, setFilterData] = useState<Record<string, any>>(() =>
    (columns ?? []).reduce((acc, col) => {
      if (col.field) {
        acc[col.field] = { value: "", matchMode: "startsWith" }; // Ensure correct structure
      }
      return acc;
    }, {} as Record<string, { value: string; matchMode: string }>),
  );


  const header = renderHeader();
  return (
    <div>
      <Box sx={{ mb: 2 }}>
        <h2 style={{ margin: "0 0 12px 8px", fontWeight: 500, fontSize: "18px" }}>
          Main Database
        </h2>
      </Box>
      {!open ? (
        <Box
          sx={{
            backgroundColor: "#f9f9f9",
            borderRadius: 3,
            boxShadow: 3,
            padding: 2, // Add padding for better spacing
          }}
        >
          <ReusableDataTable
            ref={dt}
            data={products} // Pass the data array
            columns={columns} // Pass the columns definition
            onFetchData={onFetchData} // Pass the function to fetch data
            emptyMessage="No data found."
            globalFilterFields={[
              "assetOwnerName",
              "harmonyCode",
              "codeType",
              "familyAsset",
            ]}
            header={header}
            onSelectionChange={(e) => setSelectedProducts(e.value)}
            paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
            selection={selectedProducts}
            selectionMode={"multiple"}
            //rowsPerPageOptions={[10, 25, 50, 70, 100]}
            //filters={filters}
            pagination={paginationData}
            setPagination={setPaginationData}
            filters={filterData}
            setFilters={setFilterData}

          />
        </Box>

      ) : null}
    </div>
  );
}

export default StockDatabase;